// SharedContext.tsx
import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

interface CartDisplay {
  id: number;
  table: string;
}

interface SharedContextType {
  cartDisplay: CartDisplay | null;
  setCartDisplay: (value: CartDisplay | null) => void;
}

const SharedContext = createContext<SharedContextType | undefined>(undefined);

export const SharedProvider = ({ children }: { children: ReactNode }) => {
  const [cartDisplay, setCartDisplay] = useState<CartDisplay | null>(() => {
    const stored = localStorage.getItem('cart_display');
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (cartDisplay) {
      localStorage.setItem('cart_display', JSON.stringify(cartDisplay));
    } else {
      localStorage.removeItem('cart_display');
    }
  }, [cartDisplay]);

  return (
    <SharedContext.Provider value={{ cartDisplay, setCartDisplay }}>
      {children}
    </SharedContext.Provider>
  );
};

export const useSharedContext = () => {
  const context = useContext(SharedContext);
  if (!context) {
    throw new Error('useSharedContext must be used within a SharedProvider');
  }
  return context;
};